import hs6 from "@/config/hs6";

const isValidCode = (code: string): code is keyof typeof hs6 => code in hs6;

export const getProductName = (code?: string, truncateAtChar?: number) => {
  if (code && isValidCode(code)) {
    const name = hs6[code];
    return truncateAtChar && name.length > truncateAtChar
      ? `${name.slice(0, truncateAtChar)}…`
      : name;
  }

  return code;
};

// Takes a text string and returns an array of lines based on character count per line.
// Optionally truncates at a given line count and add an ellipsis
export const wrap = (
  text: string,
  charsPerLine: number,
  truncateAtLine?: number
) => {
  const words = text.split(" ");
  const lines = [];
  let line = "";

  words.forEach((word) => {
    if (line.length + word.length < charsPerLine) {
      line += ` ${word}`;
    } else {
      lines.push(line);
      line = word;
    }
  });

  lines.push(line);

  if (truncateAtLine && truncateAtLine <= lines.length) {
    lines[truncateAtLine - 1] = `${lines[truncateAtLine - 1].slice(
      0,
      charsPerLine - 3
    )}…`;
    lines.length = truncateAtLine;
  }

  return lines;
};
